// App.js
import { AuthProvider } from "./context/AuthContext";
import AppContent from "./pages/AppContent/AppContent";
import { io } from "socket.io-client";
import { useEffect, useState } from "react";
import 'primeicons/primeicons.css';
import '../node_modules/primereact/resources/primereact.min.css';
import '../node_modules/primereact/resources/themes/lara-light-blue/theme.css'; // or another theme
import { SocketProvider } from "./context/SocketContext";

const socket = io(process.env.REACT_APP_SOCKET_SERVER);

function App() {
  const [callData, setCallData] = useState(null);

  useEffect(() => {
    socket.on("incoming_call", (data) => {
      console.log("Incoming call :: ", data);
      setCallData(data);
    });

    return () => {
      socket.off("incoming_call");
    };
  }, []);
  return (
    <AuthProvider>
      <SocketProvider>
        <AppContent />
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
